import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, UtensilsCrossed } from "lucide-react";
import MobileViewContainer from "@/Components/MobileViewContainer";
import Navbar from "@/Components/Common/navbar";
import { SITE_ID } from "@/assets/meta/meta";
import type { DisplayMenu } from "@/api/type";
import {
    DisplayMenuDetailModal,
    DisplayMenuGridList,
    DisplayMenuGridSkeleton,
    useDisplayMenus,
} from "./DisplayMenuShared";

export default function DisplayMenuPage() {
    const navigate = useNavigate();
    const [selectedDisplayMenu, setSelectedDisplayMenu] = useState<DisplayMenu | null>(null);
    const { displayMenus, isLoading } = useDisplayMenus(SITE_ID, true);

    return (
        <MobileViewContainer>
            {/* Navbar의 시각적 헤더는 숨기고, 모달/유저 로직만 유지 */}
            <Navbar hideHeader />
            <div className="min-h-screen bg-white pb-12">
                <header className="sticky top-0 z-999 flex items-center justify-between gap-2 border-b border-gray-200 bg-white px-3 py-3">
                    <button
                        type="button"
                        onClick={() => navigate("/")}
                        className="flex h-9 w-9 items-center justify-center rounded-full text-gray-700 hover:bg-gray-100"
                        aria-label="메인으로 돌아가기"
                    >
                        <ChevronLeft size={22} />
                    </button>
                    <h1 className="text-base font-semibold text-gray-900">메뉴 안내</h1>
                    {/* 우측 균형용 spacer (뒤로가기 버튼과 대칭) */}
                    <div className="h-9 w-9" aria-hidden />
                </header>

                <div className="px-5 py-6">
                    {isLoading ? (
                        <DisplayMenuGridSkeleton />
                    ) : displayMenus.length > 0 ? (
                        <DisplayMenuGridList
                            displayMenus={displayMenus}
                            onSelect={setSelectedDisplayMenu}
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
                            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
                                <UtensilsCrossed size={28} className="text-gray-400" />
                            </div>
                            <h2 className="mt-5 text-base font-bold text-gray-800">
                                아직 등록된 메뉴가 없어요
                            </h2>
                            <p className="mt-2 text-sm leading-relaxed text-gray-700">
                                메뉴 안내가 준비되면
                                <br />
                                이곳에서 확인하실 수 있습니다.
                            </p>
                        </div>
                    )}
                </div>
            </div>

            <DisplayMenuDetailModal
                displayMenu={selectedDisplayMenu}
                onClose={() => setSelectedDisplayMenu(null)}
            />
        </MobileViewContainer>
    );
}
